import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "none",
  "fill-rule": "evenodd"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M26 14c0 6.627-5.373 12-12 12S2 20.627 2 14 7.373 2 14 2s12 5.373 12 12",
    stroke: "#FFF",
    "stroke-width": "3",
    fill: "#6EBF43"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.91 13.946a.204.204 0 0 1-.25.021c-1.897-1.203-3.948-.59-4.393-.49a.203.203 0 0 1-.043.005.226.226 0 0 1-.204-.149c-.057-.134.015-.26.117-.353.326-.304 2.452-2.353 4.802.574a.293.293 0 0 1-.03.392M16.09 13.946c.073.063.17.072.25.021 1.897-1.203 3.948-.59 4.393-.49a.203.203 0 0 0 .043.005.226.226 0 0 0 .204-.149c.057-.134-.015-.26-.117-.353-.326-.304-2.452-2.353-4.802.574a.293.293 0 0 0 .03.392M10 18s.65 3 4 3c3.322 0 4-3 4-3h-8z",
    fill: "#000"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}